import Overlay from "vant/lib/overlay";
import "vant/lib/overlay/style";
export default {
  name: "CuaLoading",
  components: {
    "van-overlay": Overlay
    // 'van-loading':Loading,
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit("changeLoadingShow", false);
  }
};